import { render, staticRenderFns } from "./preview_4.vue?vue&type=template&id=0b37d15b&scoped=true"
import script from "./preview_4.vue?vue&type=script&lang=js"
export * from "./preview_4.vue?vue&type=script&lang=js"
import style0 from "./preview_4.vue?vue&type=style&index=0&id=0b37d15b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b37d15b",
  null
  
)

export default component.exports